import { Container, Text, Stack } from "@chakra-ui/react"
import { NavBar } from "../components/navbar"

export const Teaching = () => {
    return (
        <>
            <NavBar selectedId={4} />
            <Container maxW={"4xl"} pb={20} mt={{ base: 8, md: 10 }}>
                <Text textAlign={"center"} fontSize={{ base: "2xl", md: "3xl" }} fontWeight={600}>Teaching</Text>
                <Stack px={{ base: 3, md: 0 }} as="ul" spacing={4} pt={10} fontSize={"lg"}>
                    <Text as="li">CSCI 1110: Introduction to Computer Science (Winter 2025)</Text>
                    <Text as="li">CSCI 5709: Advanced Topics in Web Development (Summer 2025 & Summer 2026)</Text>
                    <Text as="li">CSCI 6611/4260: Persuasive Computing Design (Winter 2026)</Text>
                    <Text as="li">CSCI 4177: Advanced Web Services (Summer 2025 & Summer 2026)</Text>
                    <Text as="li">CSCI 5601: Designing for User Experience (Summer 2026)</Text>
                </Stack>
            </Container>
        </>
    )
}